import { useState, useEffect } from 'react';
import { Card } from 'src/@/components/ui/card';
import { Table, TableHeader, TableHead, TableBody, TableRow, TableCell } from 'src/@/components/ui/table';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import { Input } from 'src/@/components/ui/input';
import { Button } from 'src/@/components/ui/button';
import { Check, Copy, Eye, MessageSquare, Lock } from 'lucide-react';
import MenuDatas2 from 'src/components/MenuDatas2';
import moment from 'moment';
import v2_actionAnalises from 'src/actions/v2/ai/v2_actionAnalises';
import useAuth from 'src/hooks/useAuth';
import { mascararTel, validaLabelMenuDatas, verifyFeatures } from 'src/utils/functions';
import { Badge } from 'src/@/components/ui/badge';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import AiAnalyzeDetailsModal from 'src/sections/@dashboard/aiAnalyse/AiAnalyzeDetailsModal';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'src/@/components/ui/select';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import getActionClienteByClienteId from 'src/actions/clientes/getActionClienteByClienteId';
import { getMensagensWhatsappDb, setChatInfo } from 'src/redux/slices/chat';
import { useDispatch, useSelector } from 'react-redux';
import v2_actionBuscarChatById from 'src/actions/v2/services/chats/v2_actionBuscarChatById';
import { useNavigate } from 'react-router';
import DrawerChatWhatsapp from 'src/sections/@chats/chat/DrawerChatWhatsapp';
import { getListaUsuariosTransferencia } from 'src/redux/slices/user';
import ModalAiChat from 'src/sections/@global/ai/ModalAiChat';
import TablePagination from '@mui/material/TablePagination';
import Iconify from 'src/components/Iconify';

const TABLE_HEAD = [
  { id: 'id', label: 'ID' },
  { id: 'phone', label: 'Telefone' },
  { id: 'chat_id', label: 'ID do Chat' },
  { id: 'date', label: 'Data' },
  { id: 'sentiment', label: 'Sentimento' },
  { id: 'nomeUsuario', label: 'Atendente' },
  { id: 'actions', label: 'Ações' },
];

export default function AiAnaliseSentimento() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, cliente } = useAuth();
  const { listaUsuariosTransferencia } = useSelector((state) => state.user);

  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterId, setFilterId] = useState('');
  const [filterPhone, setFilterPhone] = useState('');
  const [filterChatId, setFilterChatId] = useState('');
  const [filterSentiment, setFilterSentiment] = useState('');
  const [valorEscolhidoUsuario, setValorEscolhidoUsuario] = useState(null);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [inicio, setInicio] = useState(new Date());
  const [final, setFinal] = useState(new Date());
  const [periodo, setPeriodo] = useState('mes_atual');
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenuDatas = Boolean(anchorEl);

  const [loading, setLoading] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [detailsRow, setDetailsRow] = useState(null);
  const [copiedId, setCopiedId] = useState(null);
  const [copiedChatId, setCopiedChatId] = useState(null);

  const [listaClientesCanais, setListaClientesCanais] = useState([]);
  const isMultisession = cliente?.multiSession === 1;
  const [clienteIdPadrao, setClienteIdPadrao] = useState(isMultisession ? null : user?.clienteId);

  const [chat, setChat] = useState(null);
  const [openChatdetalhes, setOpenChatDetalhes] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    async function checkAccess() {
      if (!clienteIdPadrao) return;
      try {
        const res = await getActionClienteByClienteId(clienteIdPadrao);
        if (res.status === 200) {
          setHasAccess(verifyFeatures(res.data.features || [], 'ai.analise_atendimento'));
        }
      } catch (e) {
        console.log(e);
        setHasAccess(false);
      }
    }
    checkAccess();
  }, [clienteIdPadrao]);

  async function buscarListaClientesCanais() {
    try {
      if (!cliente?._id) return;
      const response_clientes_canais = await actionListaClientesCanais(cliente._id);
      setListaClientesCanais(response_clientes_canais.data.data);
      if (isMultisession && response_clientes_canais.data.data.length > 0) {
        setClienteIdPadrao(response_clientes_canais.data.data[0].cliente_id);
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    buscarListaClientesCanais();
  }, []);

  const fetchAnalises = async (
    pageParam = page,
    limitParam = limit,
    periodoParam = periodo,
    inicioParam = inicio,
    finalParam = final
  ) => {
    if (!clienteIdPadrao || !hasAccess) return;
    try {
      setLoading(true);
      let querys = `?page=${pageParam}&limit=${limitParam}`;
      if (periodoParam) querys += `&periodo=${periodoParam}`;
      if (inicioParam) querys += `&inicio=${moment(inicioParam).format('YYYY-MM-DD')}`;
      if (finalParam) querys += `&final=${moment(finalParam).format('YYYY-MM-DD')}`;

      const response = await v2_actionAnalises(clienteIdPadrao, querys);
      if (response.data.error) {
        return;
      }
      setData(response.data.data || []);
    } catch (error) {
      console.error('Erro ao buscar análises:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cliente?._id) {
      dispatch(getListaUsuariosTransferencia(cliente._id));
    }
    if (clienteIdPadrao) {
      if (isMultisession) {
        fetchAnalisesPorCanal(clienteIdPadrao);
      } else {
        fetchAnalises(page, limit, periodo, inicio, final);
      }
    }
  }, [clienteIdPadrao, hasAccess]);

  const onFiltrar = async (periodoSelecionado, acao = 'filtrar') => {
    setPeriodo(periodoSelecionado);
    setAnchorEl(null);
    setPage(1);
    if (isMultisession) {
      await fetchAnalisesPorCanal(clienteIdPadrao, 1, limit, periodoSelecionado, inicio, final);
    } else {
      await fetchAnalises(1, limit, periodoSelecionado, inicio, final);
    }
  };

  const getSentimentColor = (sentiment) => {
    const value = parseInt(sentiment);
    if (value >= 4) return "bg-green-100 text-green-800";
    if (value >= 3) return "bg-yellow-100 text-yellow-800";
    return "bg-red-100 text-red-800";
  };

  const handleCopy = async (text, type, rowId) => {
    try {
      await navigator.clipboard.writeText(text);
      if (type === 'id') setCopiedId(rowId);
      if (type === 'chatId') setCopiedChatId(rowId);
      setTimeout(() => {
        setCopiedId(null);
        setCopiedChatId(null);
      }, 2000);
    } catch (err) { }
  };

  const fetchAnalisesPorCanal = async (
    canalId,
    pageParam = page,
    limitParam = limit,
    periodoParam = periodo,
    inicioParam = inicio,
    finalParam = final
  ) => {
    if (!canalId || !hasAccess) return;
    try {
      setLoading(true);
      let querys = `?page=${pageParam}&limit=${limitParam}`;
      if (periodoParam) querys += `&periodo=${periodoParam}`;
      if (inicioParam) querys += `&inicio=${moment(inicioParam).format('YYYY-MM-DD')}`;
      if (finalParam) querys += `&final=${moment(finalParam).format('YYYY-MM-DD')}`;

      const response = await v2_actionAnalises(canalId, querys);
      if (response.data.error) {
        return;
      }
      setData(response.data.data || []);
      if (response.data.total) {
        setTotalPages(Math.ceil(response.data.total / limitParam));
      }
    } catch (error) {
      console.error('Erro ao buscar análises:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleApplyFilters = () => {
    let filtered = data || [];

    if (filterId) {
      const regex = new RegExp(filterId, 'i');
      filtered = filtered.filter((item) => regex.test(item._id));
    }
    if (filterPhone) {
      const regex = new RegExp(filterPhone, 'i');
      filtered = filtered.filter((item) => regex.test(item.chat_phone));
    }
    if (filterChatId) {
      const regex = new RegExp(filterChatId, 'i');
      filtered = filtered.filter((item) => regex.test(item.chat_id));
    }
    if (filterSentiment) {
      const regex = new RegExp(filterSentiment, 'i');
      filtered = filtered.filter((item) => regex.test(String(item.result.sentiment)));
    }
    if (valorEscolhidoUsuario) {
      filtered = filtered.filter((item) => item.user_id === valorEscolhidoUsuario);
    }

    setFilteredData(filtered);
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
    if (isMultisession) {
      fetchAnalisesPorCanal(clienteIdPadrao, newPage, limit);
    } else {
      fetchAnalises(newPage, limit);
    }
  };

  const handleChangeLimit = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
    if (isMultisession) {
      fetchAnalisesPorCanal(clienteIdPadrao, 1, newLimit);
    } else {
      fetchAnalises(1, newLimit);
    }
  };

  async function handleOpenDetails(chatId) {
    setOpenChatDetalhes(true);
    const res = await v2_actionBuscarChatById(chatId, null, user.id);
    setChat(res.data);
    dispatch(setChatInfo(res.data));
    dispatch(getMensagensWhatsappDb(res.data.sessao, res.data.numeroCliente));
  }

  useEffect(() => {
    handleApplyFilters();
  }, [filterId, filterPhone, filterChatId, filterSentiment, valorEscolhidoUsuario, data]);

  const onReload = () => {
    if (clienteIdPadrao) {
      if (isMultisession) {
        fetchAnalisesPorCanal(clienteIdPadrao);
      } else {
        fetchAnalises(page, limit, periodo, inicio, final);
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {chat && (
        <DrawerChatWhatsapp
          chat={chat}
          open={openChatdetalhes}
          onClose={() => {
            setChat(null);
            setOpenChatDetalhes(false);
          }}
          listaFunil={[]}
          source={'chat.supervisionar'}
        />
      )}

      {/* Header Fixo */}
      <div className="sticky top-0 z-20 bg-white/80 backdrop-blur-md border-b border-gray-100/50 px-6 py-4 shadow-sm mb-6 transition-all duration-300">
        <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-4">
          {/* Esquerda: Título e Filtros */}
          <div className="flex flex-wrap items-center gap-4 flex-1">
            {/* Identificação */}
            <div className="flex items-center gap-2 min-w-fit">
              <div className="p-2 bg-[#7C3AED]/10 rounded-lg">
                <Iconify icon="mdi:brain" className="text-[#7C3AED]" width={20} />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900">Análise de IA</h3>
                <p className="text-[10px] text-gray-500">Monitoramento de sentimento</p>
              </div>
            </div>

            <div className="h-8 w-px bg-gray-200 hidden xl:block mx-2" />

            {/* Filtros */}
            <div className="flex flex-wrap items-center gap-2 flex-1">
              {/* Período */}
              <div className="w-[180px]">
                <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-1 block pl-1">
                  Período
                </span>
                <MenuDatas2
                  anchorEl={anchorEl}
                  open={openMenuDatas}
                  onClose={() => setAnchorEl(false)}
                  inicial={inicio}
                  final={final}
                  content={validaLabelMenuDatas(periodo, inicio, final)}
                  customButton={
                    <Button
                      variant="outline"
                      className="w-full h-9 justify-between text-xs font-normal border-dashed border-gray-300 bg-transparent hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 text-gray-700"
                      onClick={(e) => setAnchorEl(e.currentTarget)}
                    >
                      <span className="truncate">{validaLabelMenuDatas(periodo, inicio, final)}</span>
                      <Iconify icon="mdi:calendar" className="ml-2 h-3.5 w-3.5 opacity-50" />
                    </Button>
                  }
                  changeInicial={(newValue) => setInicio(newValue)}
                  changeFinal={(newValue) => setFinal(newValue)}
                  onSelect={(value) => onFiltrar(value, 'filtrar')}
                  onPesquisar={() => onFiltrar(periodo)}
                />
              </div>

              {/* Canal (se multisession) */}
              {isMultisession && (
                <div className="w-[180px]">
                  <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-1 block pl-1">
                    Canal
                  </span>
                  <Select
                    value={clienteIdPadrao}
                    onValueChange={(e) => {
                      let value = e;
                      setClienteIdPadrao(value);
                      fetchAnalisesPorCanal(value);
                    }}
                  >
                    <SelectTrigger className="h-9 text-xs border-gray-200 bg-white text-gray-900 focus:ring-[#7C3AED]/20">
                      <SelectValue placeholder="Selecione..." />
                    </SelectTrigger>
                    <SelectContent>
                      {listaClientesCanais.map((item) => (
                        <SelectItem key={item.cliente_id} value={item.cliente_id}>
                          {item.nome || "undefined"}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}

              {/* Usuário */}
              <div className="w-[160px]">
                <span className="text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-1 block pl-1">
                  Usuário
                </span>
                <Select
                  value={valorEscolhidoUsuario || "all"}
                  onValueChange={(e) => {
                    let value = e === "all" ? null : e;
                    setValorEscolhidoUsuario(value);
                  }}
                >
                  <SelectTrigger className="h-9 text-xs border-gray-200 bg-white text-gray-900 focus:ring-[#7C3AED]/20">
                    <SelectValue placeholder="Todos" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Todos</SelectItem>
                    {listaUsuariosTransferencia.map((item) => (
                      <SelectItem key={item._id} value={item._id}>
                        {item.firstName}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {/* Mais Filtros Popover */}
              <div className="flex items-end h-[56px] pb-[1px]">
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className="h-9 px-3 border-dashed border-gray-300 text-xs text-gray-600 hover:border-violet-500 hover:text-violet-600 hover:bg-violet-50 bg-transparent"
                    >
                      <Iconify icon="mdi:filter-plus" className="mr-2 h-4 w-4" />
                      Mais filtros
                      {(!!filterSentiment || !!filterId || !!filterChatId || !!filterPhone) && (
                        <span className="ml-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-violet-100 text-[10px] font-medium text-violet-800">
                          {(!!filterSentiment ? 1 : 0) +
                            (!!filterId ? 1 : 0) +
                            (!!filterChatId ? 1 : 0) +
                            (!!filterPhone ? 1 : 0)}
                        </span>
                      )}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-80 p-4" align="start">
                    <div className="space-y-4">
                      <h4 className="font-medium text-sm text-gray-900 border-b border-gray-200 pb-2">
                        Filtros Adicionais
                      </h4>
                      <div className="space-y-3">
                        {/* Filtro Sentimento */}
                        <div>
                          <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block">
                            Sentimento
                          </label>
                          <Select
                            value={filterSentiment || "all"}
                            onValueChange={(e) => {
                              setFilterSentiment(e === "all" ? null : e);
                            }}
                          >
                            <SelectTrigger className="h-9 text-xs w-full">
                              <SelectValue placeholder="Todos" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="all">Todos</SelectItem>
                              {[
                                { value: "1", label: '1 - Muito Insatisfeito' },
                                { value: "2", label: '2 - Insatisfeito' },
                                { value: "3", label: '3 - Neutro' },
                                { value: "4", label: '4 - Satisfeito' },
                                { value: "5", label: '5 - Muito Satisfeito' },
                              ].map((item) => (
                                <SelectItem key={item.value} value={item.value}>
                                  {item.label}
                                </SelectItem>
                              ))}
                            </SelectContent>
                          </Select>
                        </div>

                        {/* ID da Análise */}
                        <div>
                          <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block">
                            ID da Análise
                          </label>
                          <Input
                            placeholder="Pesquisar por ID"
                            value={filterId}
                            onChange={(e) => setFilterId(e.target.value)}
                            className="h-9 text-xs bg-white"
                          />
                        </div>

                        {/* ID do Chat */}
                        <div>
                          <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block">
                            ID do Chat
                          </label>
                          <Input
                            placeholder="Pesquisar por Chat ID"
                            value={filterChatId}
                            onChange={(e) => setFilterChatId(e.target.value)}
                            className="h-9 text-xs bg-white"
                          />
                        </div>

                        {/* Telefone */}
                        <div>
                          <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5 block">
                            Telefone
                          </label>
                          <Input
                            placeholder="Pesquisar por Telefone"
                            value={filterPhone}
                            onChange={(e) => setFilterPhone(e.target.value)}
                            className="h-9 text-xs bg-white"
                          />
                        </div>
                      </div>
                    </div>
                  </PopoverContent>
                </Popover>
              </div>
            </div>
          </div>

          {/* Direita: Ações */}
          <div className="flex flex-col md:flex-row items-center gap-3 w-full md:w-auto">
            <ModalAiChat
              triggerLabel="Analise com IA"
              buttonDisabled={filteredData.length === 0}
              dataSendAi={{ ids: filteredData.map((i) => i._id) }}
            />
            <Button
              className="h-9 w-9 p-0 rounded-lg border-dashed border-gray-300 text-gray-600 hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-[#7C3AED]/5"
              variant="outline"
              onClick={onReload}
              title="Recarregar"
            >
              <Iconify icon="mdi:reload" width={18} />
            </Button>
          </div>
        </div>
      </div>

      <div className="max-w-[90%] mx-auto pb-10 w-full">
        <Card className="rounded-xl shadow-sm border border-gray-100 overflow-hidden bg-white">
          <div className="p-0 relative">
            {!hasAccess && (
              <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-white/60 backdrop-blur-sm rounded-xl border border-white/20 overflow-hidden transition-all duration-500">
                <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-white/60 to-white/90"></div>
                <div className="bg-white/90 p-8 rounded-3xl shadow-2xl border border-white/50 text-center max-w-md backdrop-blur-xl relative z-10 animate-in fade-in zoom-in-95 duration-500">
                  <div className="w-16 h-16 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-sm ring-1 ring-black/5">
                    <Lock className="w-8 h-8 text-indigo-600" />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-800 mb-3 tracking-tight">
                    Ative o módulo de análise de atendimento
                  </h3>
                  <p className="text-slate-600 mb-8 leading-relaxed text-sm">
                    Esta análise detalhada é exclusiva do módulo{' '}
                    <strong>Análise de atendimento</strong>. Ative agora para acessar resumos,
                    análise de sentimento e recomendações estratégicas da IA. Entre em contato com o
                    suporte para mais informações.
                  </p>
                </div>
              </div>
            )}

            <ScrollArea className="h-[calc(100vh-240px)] w-full">
              <Table>
                <TableHeader className="bg-gray-50/80 p-2 text-xs sticky top-0 z-10 backdrop-blur-sm">
                  <TableRow>
                    {TABLE_HEAD.map((head) => (
                      <TableHead key={head.id} className="text-xs font-semibold text-gray-600 h-10">
                        {head.label}
                      </TableHead>
                    ))}
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={7} className="p-8 text-center h-[300px]">
                        <div className="flex flex-col items-center justify-center gap-2">
                          <Iconify
                            icon="eos-icons:loading"
                            width={24}
                            className="animate-spin text-gray-400"
                          />
                          <span className="text-sm text-gray-400">Carregando análises...</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : filteredData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={7} className="p-12 text-center text-gray-500 h-[300px]">
                        <div className="flex flex-col items-center justify-center gap-3">
                          <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
                            <Iconify
                              icon="mdi:feature-search-outline"
                              width={24}
                              className="text-gray-400"
                            />
                          </div>
                          <p className="font-medium text-gray-900">Nenhuma análise encontrada</p>
                          <p className="text-xs text-gray-500">Tente ajustar seus filtros</p>
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredData
                      .slice((page - 1) * limit, (page - 1) * limit + limit)
                      .map((row) => (
                        <TableRow
                          key={row._id}
                          className="border-b hover:bg-violet-50/30 transition-colors group"
                        >
                          <TableCell className="p-4 text-xs text-gray-600 font-mono">
                            <div className="flex items-center gap-2">
                              <span className="truncate max-w-[80px]">{row._id.slice(0, 8)}...</span>
                              <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => handleCopy(row._id, 'id', row._id)}
                                className="h-6 w-6 hover:bg-gray-200 opacity-0 group-hover:opacity-100 transition-opacity"
                                title="Copiar ID"
                              >
                                {copiedId === row._id ? (
                                  <Check className="h-3 w-3 text-green-600" />
                                ) : (
                                  <Copy className="h-3 w-3 text-gray-600" />
                                )}
                              </Button>
                            </div>
                          </TableCell>
                          <TableCell className="p-4 text-xs text-gray-600">
                            {mascararTel(row.chat_phone)}
                          </TableCell>
                          <TableCell className="p-4 text-xs text-gray-600 font-mono">
                            <div className="flex items-center gap-2">
                              <span className="truncate max-w-[80px]">
                                {row.chat_id.slice(0, 8)}...
                              </span>
                              <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => handleCopy(row.chat_id, 'chatId', row._id)}
                                className="h-6 w-6 hover:bg-gray-200 opacity-0 group-hover:opacity-100 transition-opacity"
                                title="Copiar ID do chat"
                              >
                                {copiedChatId === row._id ? (
                                  <Check className="h-3 w-3 text-green-600" />
                                ) : (
                                  <Copy className="h-3 w-3 text-gray-600" />
                                )}
                              </Button>
                            </div>
                          </TableCell>
                          <TableCell className="p-4 text-xs text-gray-600">
                            {format(new Date(row.date), "dd/MM/yyyy HH:mm", { locale: ptBR })}
                          </TableCell>
                          <TableCell className="p-4">
                            <Badge
                              className={`${getSentimentColor(
                                row.result.sentiment
                              )} px-2.5 py-0.5 rounded-full text-[10px] font-semibold border-0`}
                            >
                              {row.result.sentiment ? Number(row.result.sentiment) : 'N/A'}
                            </Badge>
                          </TableCell>
                          <TableCell className="p-4 text-xs text-gray-600">
                            {row.nomeUsuario || '-'}
                          </TableCell>
                          <TableCell className="p-4">
                            <div className="flex gap-1">
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => {
                                  setDetailsRow(row);
                                  setOpenDetails(true);
                                }}
                                className="h-7 w-7 p-0 hover:bg-violet-100 hover:text-violet-700"
                                title="Ver detalhes da análise"
                              >
                                <Eye className="h-3.5 w-3.5" />
                              </Button>
                              <Button
                                variant="ghost"
                                size="sm"
                                onClick={() => handleOpenDetails(row.chat_id)}
                                className="h-7 w-7 p-0 hover:bg-blue-100 hover:text-blue-700"
                                title="Ir para o chat"
                              >
                                <MessageSquare className="h-3.5 w-3.5" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </ScrollArea>

            <div className="border-t border-gray-100 bg-white p-1">
              <TablePagination
                component="div"
                labelRowsPerPage="Linhas por página"
                labelDisplayedRows={({ from, to, count }) => `${from} - ${to} de ${count}`}
                count={filteredData.length}
                rowsPerPage={limit}
                page={page - 1}
                rowsPerPageOptions={[10, 25, 50]}
                onPageChange={(event, newPage) => handleChangePage(newPage + 1)}
                onRowsPerPageChange={(e) => handleChangeLimit(Number(e.target.value))}
                sx={{
                  '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                    fontSize: '12px',
                    color: '#6b7280',
                  },
                  '.MuiTablePagination-select': { fontSize: '12px' },
                }}
              />
            </div>
          </div>
        </Card>

        <AiAnalyzeDetailsModal
          open={openDetails}
          onClose={() => setOpenDetails(false)}
          data={detailsRow}
        />
      </div>
    </div>
  );
}
